// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-selection-button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin: 0 auto;
  gap: 40px;
  margin-top: 24px;
  margin-bottom: 12px;
}
@media screen and (max-width: 900px) {
  .simple-selection-button-container {
    gap: 20px;
  }
}

.simple-selection-button {
  min-width: 0 !important; /* Override MUI's default min-width */
  width: auto !important; /* Allow button to fit content */
  height: 40px;
  padding: 0 4px !important; /* Add just 4px padding on sides */
  white-space: nowrap;
  font-size: 20px !important;
  background-color: white !important; /* Ensure background stays white */
  border: 1px solid #9D9D9D !important; /* Ensure the border is always visible */
  color: #9D9D9D !important; /* Ensure text color stays #9D9D9D */
  cursor: pointer;
}
.simple-selection-button:hover {
  background-color: white !important; /* Force background to stay white on hover */
  color: #9D9D9D !important; /* Ensure text color stays #9D9D9D on hover */
  border: 1px solid #9D9D9D !important; /* Ensure border stays the same on hover */
}
.simple-selection-button.active {
  background-color: #E8E8E8 !important; /* Active state background */
  border: 1px solid #002129 !important; /* Active state border */
  color: #002129 !important; /* Active state text color */
}
@media (max-width: 900px) {
  .simple-selection-button {
    height: 33px;
    padding: 0 4px !important; /* Maintain the same padding on small screens */
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/GamePageComponents/TabSelectionButtons/SimpleSelectionButtons.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EAXJ;IAYM,SAAA;EAEJ;AACF;;AACE;EACE,uBAAA,EAAA,qCAAA;EACA,sBAAA,EAAA,gCAAA;EACA,YAAA;EACA,yBAAA,EAAA,kCAAA;EACA,mBAAA;EACA,0BAAA;EACA,kCAAA,EAAA,kCAAA;EACA,oCAAA,EAAA,wCAAA;EACA,yBAAA,EAAA,oCAAA;EACA,eAAA;AAEJ;AAAI;EACE,kCAAA,EAAA,4CAAA;EACA,yBAAA,EAAA,6CAAA;EACA,oCAAA,EAAA,0CAAA;AAEN;AACI;EACE,oCAAA,EAAA,4BAAA;EACA,oCAAA,EAAA,wBAAA;EACA,yBAAA,EAAA,4BAAA;AACN;AAEI;EAxBF;IAyBI,YAAA;IACA,yBAAA,EAAA,+CAAA;IACA,0BAAA;EACJ;AACF","sourcesContent":[".simple-selection-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 95%;\n    margin: 0 auto;\n    gap: 40px;\n    margin-top: 24px;\n    margin-bottom: 12px;\n  \n    @media screen and (max-width: 900px) {\n      gap: 20px;\n    }\n  }\n  \n  .simple-selection-button {\n    min-width: 0 !important; /* Override MUI's default min-width */\n    width: auto !important; /* Allow button to fit content */\n    height: 40px;\n    padding: 0 4px !important; /* Add just 4px padding on sides */\n    white-space: nowrap;\n    font-size: 20px !important;\n    background-color: white !important; /* Ensure background stays white */\n    border: 1px solid #9D9D9D !important; /* Ensure the border is always visible */\n    color: #9D9D9D !important; /* Ensure text color stays #9D9D9D */\n    cursor: pointer;\n  \n    &:hover {\n      background-color: white !important; /* Force background to stay white on hover */\n      color: #9D9D9D !important; /* Ensure text color stays #9D9D9D on hover */\n      border: 1px solid #9D9D9D !important; /* Ensure border stays the same on hover */\n    }\n  \n    &.active {\n      background-color: #E8E8E8 !important; /* Active state background */\n      border: 1px solid #002129 !important; /* Active state border */\n      color: #002129 !important; /* Active state text color */\n    }\n  \n    @media (max-width: 900px) {\n      height: 33px;\n      padding: 0 4px !important; /* Maintain the same padding on small screens */\n      font-size: 12px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
